import { fork } from 'redux-saga/effects';

// Watchers
import employeeSagas from './employeeSagas';
import manageEmployeeSagas from './manageEmployeeSagas';

export default function* () {
    yield fork(employeeSagas);
    yield fork(manageEmployeeSagas);
}
